<script>
import Layout from "@/views/layouts/main.vue";
import CommonTableComponent from "@/components/table.vue";
import appConfig from "@/app.config.json";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import router from "@/mixins/router";
import DatePicker from "vue2-datepicker";
import apiEndpoints from "@/services/apiEndpoints";
import { mapGetters } from "vuex";

import SearchDataProjectModal from "@/components/InputSearchModal/SearchDataProjectModal.vue";
import SearchDataCustomerModal from "@/components/InputSearchModal/SearchDataCustomerModal.vue";
import SearchDataDischargerModal from "@/components/InputSearchModal/SearchDataDischargerModal.vue";
import SearchDataDischagerSiteModal from "@/components/InputSearchModal/SearchDataDischargerSiteModal.vue";
import SearchDataWasteCategoryAllModal from "@/components/InputSearchModal/SearchDataWasteCategoryModal.vue";
import SearchDataVendorSiteAllModal from "@/components/InputSearchModal/SearchDataVendorSiteModal.vue";
import SearchDataWorkOrderModal from "@/components/InputSearchModal/SearchDataWorkOrderModal.vue";

export default {
  name: "WasteOrService.register",
  page: {
    title: "作業指示別廃棄物・サービス一覧",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [tableSearch, pagination, router],
  components: {
    Layout,
    DatePicker,
    CommonTableComponent,
    SearchDataProjectModal,
    SearchDataCustomerModal,
    SearchDataDischargerModal,
    SearchDataDischagerSiteModal,
    SearchDataWasteCategoryAllModal,
    SearchDataVendorSiteAllModal,
    SearchDataWorkOrderModal
  },
  data() {
    return {
      wastesOrServicesList: [],
      caseRowSpans: [],
      workOrderRowSpans: [],
      filters: {
        case: this.$route.query.case || "",
        customer: this.$route.query.customer || "",
        discharger: this.$route.query.discharger || "",
        discharger_site: this.$route.query.discharger_site || "",
        work_order_type: this.$route.query.work_order_type?.split(",") || [],
        work_order_name: this.$route.query.work_order_name || "",
        waste_category_of_treatment_name_abbreviated:
          this.$route.query.waste_category_of_treatment_name_abbreviated || "",
        vendor_site_name_abbreviated:
          this.$route.query.vendor_site_name_abbreviated || "",
        column: this.$route.query.column || "cases.case_cd",
        dir: this.$route.query.dir || "ASC",
        page: this.$route.query.page || 1,
        searchToken: 0
      },
      isLoading: false,

      dataSelected: {
        workOrderId: null,
        reservationDate: {
          date: new Date().toISOString().substring(0, 10),
          selectTimeZone: 1
        },
        wasteOrServices: []
      },
      temporary_selected_wastes_or_services: {
        work_order: {},
        wastes_or_services_by_work_order: [],
        reservation_date: {
          date: "",
          zz_day_of_time_zone_id: ""
        }
      },
      searchError: null,
      btnBackText: this.$lang.button.back,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const sendApiProject = await this.$http.get(
        apiEndpoints.waste_or_service_register,
        this.filters
      );
      const { status, data } = sendApiProject;

      if (status && data.result) {
        //this.total_records = data.result.total;
        //this.cases = data.result.data;
        this.wastesOrServicesList = data.result.pageResult.data;
        this.caseRowSpans = data.result.caseRowSpans;
        this.workOrderRowSpans = data.result.workOrderRowSpans;
        const meta = this.$_.isEmpty(data.result.pageResult.meta) ? [] : data.result.pageResult.meta;
        this.setMeta(meta);
      } else {
        this.searchError = data.errors;
      }
      this.isLoading = false;
    },
    search() {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    onChangePage(event, page) {
      this.filters.page = page;
      this.updateUrlFilters();
    },
    onSelectData(data) {
      this.filters = data;
    },
    clearDataSearch() {
      for (const key in this.filters) {
        this.filters[key] = "";
      }
      this.filters.column = "cases.case_cd";
      this.filters.dir = "ASC";
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    submit() {
      // 作業未選択の場合、なぜわざわざ次の画面に行ってから返ってくるような作りになっているんだろう
      if(this.dataSelected.workOrderId){
        // IDそのものではなくそのIDのオブジェクトを渡すが、いずれか一つでよい。
        let tmp = this.wastesOrServicesList.filter(itm => itm.work_order_id ==this.dataSelected.workOrderId);
        this.temporary_selected_wastes_or_services.work_order  = tmp[0].work_order;
          // this.dataSelected.wasteOrServicesは選択した作業廃棄物のID一覧
        this.temporary_selected_wastes_or_services.wastes_or_services_by_work_order 
          = this.wastesOrServicesList.filter(itm => this.dataSelected.wasteOrServices.includes(itm.id));
      }
      this.temporary_selected_wastes_or_services.reservation_date.date = this.dataSelected.reservationDate.date;
      this.temporary_selected_wastes_or_services.reservation_date.zz_day_of_time_zone_id = this.dataSelected.reservationDate.selectTimeZone;

      this.$store.dispatch("schedule/registerScheduleWasteOrService",this.temporary_selected_wastes_or_services);
      this.$router.push({ name: "projects.schedules.register_by_work_order" });
    },
    back() {
      this.$router.push({ name: "schedule.car.list" });
    },
    getRowspanForCase(wosItem) {
      let rowspan = 0;
      rowspan = this.wastesOrServicesList.filter(itm=>itm.work_order.case_id == wosItem.work_order.case_id).length;
      return rowspan;
    },
    isRowSpanForCase(wosItem, idx){
      // ひとつ前のと比較
      if(!this.wastesOrServicesList[idx-1])return true;
      if(wosItem.work_order.case_id != this.wastesOrServicesList[idx-1].work_order.case_id) return true;
      return false;
    },
    getRowspanForWorkOrder(wosItem) {
      let rowspan = 0;
      rowspan = this.wastesOrServicesList.filter(itm=>itm.work_order_id == wosItem.work_order_id).length;
      return rowspan;
    },
    isRowSpanForWorkOrder(wosItem,idx){
      if(!this.wastesOrServicesList[idx-1])return true;
      if(wosItem.work_order_id != this.wastesOrServicesList[idx-1].work_order_id) return true;
      return false;
    },
    handleCheckBoxDisable(workOrderId) {
      return (
        this.dataSelected.wasteOrServices.length > 0 &&
        this.dataSelected.workOrderId !== workOrderId
      );
    },
    handleSelectWasteOrServices(workOrderId) {
      if (this.dataSelected.workOrderId !== workOrderId) {
        this.dataSelected.workOrderId = workOrderId;
      }
    },
    getNameWasteOrService(wasteOrService) {
      if(wasteOrService.waste){
        return wasteOrService.waste.name
      }
      return wasteOrService.service.name ?? ''
    },
    getWasteCategoryOfTreatmentName(disposal_site) {
      return disposal_site?.disposal_site_by_waste_category?.waste_category_of_treatment?.name_abbreviated ?? ""
    },
    getVendorSiteOfTreatmentName(disposal_site) {
      return disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.name_abbreviated ?? "";
    },
    getTreatmentNameMethod(disposal_site) {
      return disposal_site?.disposal_site_by_waste_category?.zz_treatment_method?.treatment_method ?? "";
    },
    onClickRow(workOrderId, wasteOrServiceId){

      if (!! this.dataSelected.workOrderId && workOrderId !== this.dataSelected.workOrderId && this.dataSelected.wasteOrServices.length >0) {
        return;
      }
      if (!this.dataSelected.wasteOrServices.includes(wasteOrServiceId)) {
        this.dataSelected.wasteOrServices.push(wasteOrServiceId);
      } else {
        const index = this.dataSelected.wasteOrServices.indexOf(wasteOrServiceId)
        if (index > -1) {
          this.dataSelected.wasteOrServices.splice(index, 1)
        }
      }
      this.handleSelectWasteOrServices(workOrderId);
    }
  },
  computed: {
    ...mapGetters("options", ["work_order_type_options"]),
    zz_day_of_time_zones() {
      return (
        this.$store.getters["options/options_tables"].zz_day_of_time_zones ?? []
      );
    },
    headers() {
      return [
        {
          text: "AK管理"
        },
        {
          text: "商流名"
        },
        {
          text: "作業指示番号"
        },
        {
          text: "作業指示名"
        },
        {
          text: "作業分類"
        },
        {
          text: "選択"
        },
        {
          text: "廃棄物・サービス名"
        },
        {
          text: "廃棄物種類"
        },
        {
          text: "運搬先"
        },
        {
          text: "処分方法"
        },
        {
          text: "TK管理番号"
        },
        {
          text: "得意先名"
        },
        {
          text: "JG管理番号"
        },
        {
          text: "事業場名"
        },
        {
          text: "JJ管理番号"
        },
        {
          text: "事業場名"
        }
      ];
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler(newVal, oldVal) {
        this.updateUrlFilters();
      }
    },
    'dataSelected.wasteOrServices': function (newValue) {
      if (!newValue.length) {
        this.dataSelected.workOrderId = null;
      }
    },
  }
};
</script>

<template>
  <layout>
    <b-row>
      <b-card>
        <div class="d-flex justify-content-end">
          <b-button size="lg" variant="primary" @click="back()" class="me-2">
            <i class='fas fa-arrow-alt-circle-left'></i> {{ btnBackText }}
          </b-button>
        </div>
        <div data-v-34555929="" class="mb-3 title-detail">■作業設定</div>
        <SearchDataProjectModal
          :dataSearch="filters"
          :errorValid="this.searchError"
          @dataSelected="onSelectData"
        />
        <b-row>
          <b-col >
            <SearchDataCustomerModal
              :dataSearch="filters"
              :errorValid="this.searchError"
              @dataSelected="onSelectData"
            />
          </b-col>
          <b-col>
            <SearchDataDischargerModal
              :dataSearch="filters"
              :errorValid="this.searchError"
              @dataSelected="onSelectData"
            />
          </b-col>
        </b-row>
        <div>
          <SearchDataDischagerSiteModal
            :dataSearch="filters"
            :errorValid="this.searchError"
            @dataSelected="onSelectData"
          />
        </div>
        <div class="d-flex flex-row">
          <label
            class="col-form-label text-nowrap me-2"
            for="work_order_type_options"
          >
            作業分類
          </label>
          <b-form-checkbox-group
            v-if="work_order_type_options && work_order_type_options.length > 0"
            class="checkbox-group"
            id="work_order_type_options"
            v-model="filters.work_order_type"
            :options="work_order_type_options"
          ></b-form-checkbox-group>
        </div>
        <div class="mb-2">
          <SearchDataWorkOrderModal
            :dataSearch="filters"
            :errorValid="this.searchError"
            @dataSelected="onSelectData"
          />
        </div>
        <div class="row mb-2">
          <div class="col-md-6">
            <SearchDataWasteCategoryAllModal
              :dataSearch="filters"
              :errorValid="this.searchError"
              @dataSelected="onSelectData"
            />
          </div>
          <div class="col-md-6">
            <SearchDataVendorSiteAllModal
              :dataSearch="filters"
              :errorValid="this.searchError"
              @dataSelected="onSelectData"
            />
          </div>
        </div>
        <b-row>
          <div class="d-flex justify-content-center align-items-center">
            <b-button
              size="lg"
              variant="primary"
              @click="search()"
              class="me-2"
            >
              <i class="fas fa-search"></i> {{ this.$lang.button.search }}
            </b-button>
            <b-button @click="clearDataSearch()" variant="dark" size="lg">
              <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
            </b-button>
          </div>
        </b-row>
      </b-card>
      <b-card>
        <div class="mb-2">
          ※作業分類を1つ選択し、その中で複数の廃棄物・サービスの依頼が必要であればチェック願います。
        </div>
        <b-row>
          <b-card class="p-0">
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
                <tr>
                  <th
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                    <tr
                      v-if="wastesOrServicesList"
                      v-for="(wosItem,wastesOrServicesIndex) in wastesOrServicesList"
                      :key="'case' + wosItem.work_order.case_id + wosItem.id + wastesOrServicesIndex"
                    >
                      <td
                        v-if="isRowSpanForCase(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForCase(wosItem)"
                      >
                        {{ wosItem.work_order.case.case_cd }}
                      </td>
                      <td
                        v-if="isRowSpanForCase(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForCase(wosItem)"
                      >
                        {{ wosItem.work_order.case.case_name }}
                      </td>
                      <td
                        v-if="isRowSpanForWorkOrder(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForWorkOrder(wosItem)"
                      >
                        {{ wosItem.work_order.id }}
                      </td>
                      <td
                        v-if="isRowSpanForWorkOrder(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForWorkOrder(wosItem)"
                      >
                        {{ wosItem.work_order.name }}
                      </td>
                      <td
                        v-if="isRowSpanForWorkOrder(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForWorkOrder(wosItem, true)"
                      >
                        {{ wosItem.work_order.work_order_type.work_order_type }}
                      </td>
                      <td
                        class="text-center"
                        @click="onClickRow(wosItem.work_order.id, wosItem.id)"
                      >
                        <b-form-checkbox
                          :disabled="handleCheckBoxDisable(wosItem.work_order.id)"
                          @change="handleSelectWasteOrServices(wosItem.work_order.id)"
                          v-model="dataSelected.wasteOrServices"
                          :value="wosItem.id"
                        />
                      </td>

                      <td
                        @click="onClickRow(wosItem.work_order.id, wosItem.id)"
                      >
                        {{
                          getNameWasteOrService(wosItem)
                        }}
                      </td>

                      <td
                        @click="onClickRow(wosItem.work_order_id, wosItem.id)"
                      >
                        {{
                          getWasteCategoryOfTreatmentName(wosItem.disposal_site)
                        }}
                      </td>

                      <td
                        @click="onClickRow(wosItem.work_order_id, wosItem.id)"
                      >
                        {{
                          getVendorSiteOfTreatmentName(wosItem.disposal_site)
                        }}
                      </td>

                      <td
                        @click="onClickRow(wosItem.work_order_id,wosItem.id)"
                      >
                        {{
                          getTreatmentNameMethod(wosItem.disposal_site)
                        }}
                      </td>

                      <td
                        v-if="isRowSpanForCase(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForCase(wosItem)"
                      >
                        {{ wosItem.work_order.case.customer.customer_cd }}
                      </td>
                      <td
                        v-if="isRowSpanForCase(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForCase(wosItem)"
                      >
                        {{ wosItem.work_order.case.customer.name_abbreviated }}
                      </td>
                      <td
                        v-if="isRowSpanForCase(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForCase(wosItem)"
                      >
                        {{ wosItem.work_order.case.discharger.discharger_cd }}
                      </td>
                      <td
                        v-if="isRowSpanForCase(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForCase(wosItem)"
                      >
                        {{ wosItem.work_order.case.discharger.name_abbreviated }}
                      </td>
                      <td
                        v-if="isRowSpanForCase(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForCase(wosItem)"
                      >
                        {{ wosItem.work_order.case.discharger_site.discharger_site_cd }}
                      </td>
                      <td
                        v-if="isRowSpanForCase(wosItem,wastesOrServicesIndex)"
                        :rowspan="getRowspanForCase(wosItem, true)"
                      >
                        {{ wosItem.work_order.case.discharger_site.name_abbreviated }}
                      </td>
                    </tr>

                
                <tr v-if="!this.wastesOrServicesList.length && !isLoading">
                  <td :colspan="headers.length" class="text-center">
                    データなし。
                  </td>
                </tr>
              </tbody>
            </CommonTableComponent>
            <div
              class="d-flex justify-content-between mt-3"
              v-if="meta.total && Object.keys(meta).length"
            >
              <div class="d-flex align-items-center">
                <b-pagination
                  v-model="filters.page"
                  :total-rows="meta.total"
                  :per-page="meta.per_page"
                ></b-pagination>
              </div>
              <div class="d-flex align-items-center">
                <div class="me-2">
                  {{ meta.from }} - {{ meta.to }} / {{ meta.total }}
                </div>
              </div>
            </div>
          </b-card>
        </b-row>
      </b-card>
      <b-card>
        <div class="mb-3 title-detail">■予約日時設定</div>
        <div class="mb-3">
          <div class="schedule d-flex mb-2">
            <label class="lbl-custom" for="dateStart">作業年月日</label>
            <ValidationProvider
              rules="required"
              :custom-messages="{ required: '作業年月日は必須項目です' }"
              v-slot="{ errors, classes }"
            >
              <div :class="classes" class="input-control">
                <date-picker
                  id="dateStart"
                  lang="ja"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  value-type="format"
                  type="date"
                  v-model="dataSelected.reservationDate.date"
                ></date-picker>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
          <div class="schedule d-flex col-md-2">
            <label class="lbl-custom" for="time-zone">作業時間帯</label>
            <b-form-select
              id="time-zone"
              :options="zz_day_of_time_zones"
              value-field="id"
              text-field="day_of_time_zone"
              v-model="dataSelected.reservationDate.selectTimeZone"
              class="mb-3 form-select custom-select"
            ></b-form-select>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center mb-4">
          <b-button size="lg" variant="primary" @click="submit()" class="me-2">
            <i class="fas fa-arrow-alt-circle-right"></i> {{ this.$lang.button.next }}
          </b-button>
          <b-button size="lg" variant="primary" @click="back()" >
            <i class='fas fa-arrow-alt-circle-left'></i> {{ btnBackText }}
          </b-button>
        </div>
      </b-card>
    </b-row>
  </layout>
</template>

<style lang="css">
.checkbox-group {
  display: flex;
  column-gap: 10px;
  align-items: center;
}
.title-detail {
  font-size: 16px;
  font-weight: 600;
}
.lbl-custom {
  flex: 0 0 100px;
}
</style>
